import { jsx as l } from "react/jsx-runtime";
import { c as p } from "react/compiler-runtime";
import { ToggleButton as s } from "@mui/material";
import { forwardRef as f } from "react";
const c = f((e, m) => {
  const o = p(5);
  let t;
  o[0] !== e ? ({
    ...t
  } = e, o[0] = e, o[1] = t) : t = o[1];
  let r;
  return o[2] !== t || o[3] !== m ? (r = /* @__PURE__ */ l(s, { ref: m, ...t }), o[2] = t, o[3] = m, o[4] = r) : r = o[4], r;
});
export {
  c as ToggleButton
};
